import React, { useEffect, useState } from "react";
import purpleFlower from "../../assets/icons/purpleFlower.webp";
import Refresh from "../../assets/icons/Refresh";
import Close from "../../assets/icons/Close";
import { updateBlockSupplies } from "../../services/seasons";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../ui-elements/Notification";

const SeasonBlockCard = ({
  supplies,
  blockPos,
  onClose,
  updateParentInfo,
  _blockInfo,
  seasonStatus,
}) => {
  //()
  const [blockInfo, setBlockInfo] = useState(_blockInfo); //informacion del bloque
  const [sending, setSending] = useState(false); //estado de actualizacion de lista de medicina
  const changeValue = (e, supplie) => {
    //esta funcion evalua si se marca o desmarca alguna medicina
    //internamente agrega o quita los objetos supplie de la lista de medicinas del bloque
    const temp = { ...blockInfo };
    const add = e.target.checked;
    if (add) {
      temp.supplies = [...temp.supplies, supplie];
      //ejecutar ruta al back (cuando se de click en actualizar)
    } else {
      temp.supplies = temp.supplies.filter((obj) => obj.id != supplie.id);
      //ejecutar ruta al back (cuando se de click en actualizar)
    }
    setBlockInfo(temp);
    updateParentInfo(blockPos, temp.supplies); //el contenedor padre debe terner la informacion del bloque actualizada para renderizar la informacion correcta
  };
  const onClickUpdate = () => {
    const handleUpdate = async () => {
      try {
        setSending(true); //estado en actualizando...
        const execUpdateRequest = await updateBlockSupplies(
          //llamada de query
          blockInfo.id,
          blockInfo.supplies.map((obj) => obj.id) //array de id's
        );
        IS_LOCAL_ENV && console.log(execUpdateRequest);
        Notification({
          title: "Operación completada",
          text: `Se actualizó la lista de medicinas`,
          type: "Success",
        });
        setSending(false); //finalizó la actualización
      } catch (err) {
        setSending(false);
        IS_LOCAL_ENV && console.error(err);
      }
    };
    handleUpdate();
  };

  useEffect(() => {
    IS_LOCAL_ENV && console.log(blockInfo);
  }, [blockInfo]);

  return (
    <div className="flex gap-y-4 flex-col items-center justify-center py-6 px-10 border-[1px] border-accent-green font-poppins min-w-[260px] rounded-xl m-2 shadow-md bg-white">
      <div className="flex w-full justify-center relative">
        <div className="flex absolute right-[-20px] top-[-10px]">
          <button
            className="rounded-[50%] hover:bg-light-green-50 transition-all duration-100 p-1"
            onClick={(e) => {
              return onClose ? onClose() : null;
            }}
          >
            {onClose ? (
              <Close className="w-[25px] h-[25px] text-accent-green" />
            ) : (
              ""
            )}
          </button>
        </div>
        <img src={purpleFlower} className="w-[80px]" />
      </div>
      <div className="flex flex-col items-center justify-center gap-y-2">
        <h2 className="text-dark-green font-bold text-xl ">{blockInfo.name}</h2>
        <ul className="max-h-[320px] overflow-y-auto">
          {supplies.map((supplie, j) => {
            return (
              <li
                key={j}
                className="flex flex-row gap-x-2 py-1 items-center text-default-gray m-0"
              >
                <input
                  type="checkbox"
                  disabled={
                    sending || (seasonStatus && seasonStatus != "hidden")
                  }
                  checked={blockInfo.supplies.some(
                    (supply) => supply.id === supplie.id
                  )}
                  onChange={(e) => changeValue(e, supplie)}
                  className={`m-0 rounded-[2px] ${
                    seasonStatus && seasonStatus == "hidden"
                      ? "checked:bg-accent-green"
                      : "checked:bg-default-gray"
                  }  focus:ring-transparent`}
                />

                {supplie.sName}
              </li>
            );
          })}
        </ul>
      </div>
      {seasonStatus && seasonStatus == "hidden" && (
        <button
          className={` w-fit flex flex-row items-center gap-x-1 px-6 justify-center text-sm  rounded-full py-2  text-white ${
            sending
              ? "bg-default-gray cursor-not-allowed"
              : "bg-dark-green hover:bg-accent-green"
          }   transition-all duration-100 font-bold font-poppins `}
          onClick={onClickUpdate}
        >
          <span className="text-nowrap text-lg">
            {sending ? "Actualizando..." : "Actualizar"}
          </span>

          <Refresh />
        </button>
      )}
    </div>
  );
};

export default SeasonBlockCard;
